import script from "./StructuredCase.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredCase.vue?vue&type=script&setup=true&lang=js"

import "./StructuredCase.vue?vue&type=style&index=0&id=686dddb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686dddb9"]])

export default __exports__